import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateMultySelectModalsDataState,
	globalStateMultySelectModalsDataReducer,
	globalStateMultySelectModalsDataAction,
} from "./data";

export type StateMultySelectModals = {
	data: globalStateMultySelectModalsDataState;
};

export const multySelectModals = combineReducers<StateMultySelectModals>({
	data: globalStateMultySelectModalsDataReducer,
});

export const globalStateMultySelectModalsAction = {
	data: globalStateMultySelectModalsDataAction,
};

export default multySelectModals;
